export default __webpack_public_path__ + "static/explainerVideoPreview-c2a74db17094cf87d5fa603a0ef5d823.png";